import { Type } from 'class-transformer';
import { WorkflowCheckListRawDto } from './workflow-check-list-raw-dto';

export class WorkflowCheckListParametersDto {
    workflowId: number;
    communityId: number;

    @Type(() => WorkflowCheckListRawDto)
    workflowChecklistStatuses: Array<WorkflowCheckListRawDto>;
}
